import { resolve } from "inversify-react";
import * as React from "react";
import { confirmAlert } from "react-confirm-alert";
import AdminTable from "src/core/ui/admin-table";
import AdminService from "src/services/admin.service";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ArtworkInformation } from "../../../typings";

interface IArtworksTableProps {
    artworks: ArtworkInformation[];
}

interface IArtworksTableState {}

class ArtworksTable extends React.Component<IArtworksTableProps, IArtworksTableState> {
    @resolve(AdminService)
    public adminService: AdminService;

    columns: any[] = [
        {
            label: "ID",
            flex: 2,
        },
        {
            label: "ARTIST ID",
            flex: 2,
        },
        {
            label: "ARTIST NAME",
            flex: 1,
        },
        {
            label: "TITLE",
            flex: 1,
        },
        {
            label: "RARITY",
            flex: 1,
        },
        {
            label: "# EDITIONS",
            flex: 1,
        },
        {
            label: "ACTIONS",
            flex: 1,
        },
    ];

    deleteArtwork(id: number): void {
        confirmAlert({
            title: "Confirm to delete",
            message: "Are you sure to do delete artwork " + id + "?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.adminService.deleteArtwork(id),
                },
                {
                    label: "No",
                    onClick: () => close(),
                },
            ],
        });
    }

    render(): JSX.Element {
        const { artworks } = this.props;

        const artworksRows: JSX.Element[][] = artworks.map((a) => [
            <div>{a.id}</div>,
            <div>{a.artistId}</div>,
            <div>{a.artistName}</div>,
            <div>{a.title}</div>,
            <div>{a.rarity}</div>,
            <div>{a.edition_count}</div>,
            <div className="admin-options">
                <a className="negative" onClick={() => this.deleteArtwork(a.id)}>
                    Delete
                </a>
            </div>,
        ]);

        return <AdminTable columns={this.columns} rows={artworksRows} />;
    }
}

export default ArtworksTable;



// WEBPACK FOOTER //
// ./src/components/admin_panel/tables/artworks-table.tsx